import { render, staticRenderFns } from "./quotationIntegrationHistory.vue?vue&type=template&id=31a9b36b&scoped=true"
import script from "./quotationIntegrationHistory.vue?vue&type=script&lang=js"
export * from "./quotationIntegrationHistory.vue?vue&type=script&lang=js"
import style0 from "./quotationIntegrationHistory.vue?vue&type=style&index=0&id=31a9b36b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a9b36b",
  null
  
)

export default component.exports